import React, { useState, useEffect } from 'react';
import { Segment } from 'tea-component';
import Abnormal from '@/pages/intelligence/components/Abnormal';
import ArrowBottom from '@/pages/intelligence/assets/svg/selectIcon/arrow-bottom.svg';
import LineChart from '@/pages/intelligence/components/Chart/components/LineChart';
import useLineCharts from '@/pages/intelligence/components/Chart/hooks/useLineCharts';
import { valueFormat } from '@/pages/intelligence/utils/commonUtils';
import { useIntl } from 'umi';
import { TOP_CHARTS_TYPES } from '@intelligence/components/ChartBubble';

export default function StatsLineChart(props: any) {
  const {
    isLoading,
    entityType,
    metricSegments,
    metricList = [],
    metricInfo,
    lineChartData,
    dateType,
  } = props;

  const { formatMessage } = useIntl();

  const [metricSelected, setMetricSelected] = useState(metricSegments?.[0]?.value);

  // 获取折线图hooks
  const { lineOption } = useLineCharts({
    topChartsType: TOP_CHARTS_TYPES.GENRE_PROFILE_DETAILS_STATS_LINE,
    lineData: lineChartData, // 折线 数据
    dateType,
    imageType: entityType,
    metric: metricSelected,
  });

  useEffect(() => {
    setMetricSelected(metricSegments?.[0]?.value);
  }, [metricSegments]);

  return (
    <>
      <div className="dbi-stats-desc">
        {metricSegments?.length > 1 ? (
          <Segment
            value={metricSelected}
            onChange={(value: any) => {
              setMetricSelected(value);
            }}
            options={metricSegments.map((item: any) => ({
              text: formatMessage({ id: item.label }),
              value: item.value,
            }))}
          />
        ) : (
          ''
        )}
        {metricList?.length
          ? metricList?.map((item: any, index: number) => {
              return (
                <span key={index} className="dbi-stats-text">
                  {formatMessage({ id: item.label })} : {valueFormat(item.value || 0)}
                </span>
              );
            })
          : ''}
        {metricInfo ? (
          <span className="dbi-stats-desc-text">
            {metricInfo}(
            <img src={ArrowBottom} className="dbi-stats-desc-icon" />)
          </span>
        ) : (
          ''
        )}
      </div>
      <Abnormal
        isLoading={isLoading}
        isNoData={!isLoading && !lineChartData[metricSelected]?.length}
        component={
          <div className="tabdetails-echarts">
            <LineChart height={300} lineOption={lineOption} />
          </div>
        }
      />
    </>
  );
}
